import { FontRole } from "@keepoinc/site-page-react-component";

import { ColorField, FieldPair } from "../ColorField";
import { FontPicker } from "../FontsSection";

type Props = {
  role: FontRole;
  font: string;
  onPickFont: (id: string) => void;
  /** Without PLUS: the fonts other than the free one ask to subscribe instead. */
  fontLocked?: boolean;
  onFontLocked?: () => void;
  colorLabel: string;
  color: string;
  onPickColor: (color: string) => void;
  /** PLUS only: the color is shown but asks to subscribe instead of opening the picker. */
  colorLocked?: boolean;
  onColorLocked?: () => void;
};

/** A line of the Fontes group: the font of the titles (or of the texts) and their color. */
export const FontRow = (props: Props) => (
  <FieldPair>
    <FontPicker
      role={props.role}
      value={props.font}
      onPick={props.onPickFont}
      locked={props.fontLocked}
      onLocked={props.onFontLocked}
    />
    <ColorField
      label={props.colorLabel}
      color={props.color}
      onPick={props.onPickColor}
      locked={props.colorLocked}
      onLocked={props.onColorLocked}
    />
  </FieldPair>
);
